import OPTIMISM_LOGO_URL from '../assets/images/optimism.svg'
import AVALANCHE_LOGO_URL from '../assets/images/avalanche.svg'
import MANTLE_LOGO_URL from '../assets/images/mantle.png'
import LINEA_LOGO_URL from '../assets/images/linea.png'
import ARBITRUM_LOGO_URL from '../assets/images/arbitrum.svg'
import ETHEREUM_LOGO_URL from '../assets/images/ethereum-logo.png'
import POLYGON_LOGO_URL from '../assets/images/polygon-logo.png'
import CELO_LOGO_URL from '../assets/images/celo-logo.svg'
import BNB_LOGO_URL from '../assets/images/bnb-logo.svg'
import { SupportedChainId } from '@uniswap/sdk-core'

export enum SupportedNetwork {
  ETHEREUM,
  AVALANCHE,
  MANTLE,
  LINEA,
  ARBITRUM,
  OPTIMISM,
  POLYGON,
  CELO,
  BNB,
}

export type NetworkInfo = {
  chainId: SupportedChainId
  id: SupportedNetwork
  route: string
  name: string
  imageURL: string
  bgColor: string
  primaryColor: string
  secondaryColor: string
  blurb?: string
}

export const LineaNetworkInfo: NetworkInfo = {
  chainId: 59144 as SupportedChainId,
  id: SupportedNetwork.LINEA,
  route: 'linea',
  name: 'Linea',
  bgColor: '#000000',
  primaryColor: '#ffff',
  secondaryColor: '#000000',
  imageURL: LINEA_LOGO_URL,
}

export const EthereumNetworkInfo: NetworkInfo = {
  chainId: SupportedChainId.MAINNET,
  id: SupportedNetwork.ETHEREUM,
  route: '',
  name: 'Ethereum',
  bgColor: '#fc077d',
  primaryColor: '#fc077d',
  secondaryColor: '#e8cb7b',
  imageURL: ETHEREUM_LOGO_URL,
}

export const AvalancheNetworkInfo: NetworkInfo = {
  chainId: SupportedChainId.AVALANCHE,
  id: SupportedNetwork.AVALANCHE,
  route: 'avalanche',
  name: 'Avalanche',
  bgColor: '#F01B36',
  primaryColor: '#F01B36',
  secondaryColor: '#FB7876',
  imageURL: AVALANCHE_LOGO_URL,
}

export const MantleNetworkInfo: NetworkInfo = {
  chainId: 5000 as SupportedChainId,
  id: SupportedNetwork.MANTLE,
  route: 'mantle',
  name: 'Mantle',
  bgColor: '#000000',
  primaryColor: '#ffff',
  secondaryColor: '#1775ad',
  imageURL: MANTLE_LOGO_URL,
}

export const ArbitrumNetworkInfo: NetworkInfo = {
  chainId: SupportedChainId.ARBITRUM_ONE,
  id: SupportedNetwork.ARBITRUM,
  route: 'arbitrum',
  name: 'Arbitrum',
  imageURL: ARBITRUM_LOGO_URL,
  bgColor: '#9a9dab',
  primaryColor: 'rgba(173, 243, 253,1)',
  secondaryColor: 'rgba(173, 243, 253,0.9)',
}

export const OptimismNetworkInfo: NetworkInfo = {
  chainId: SupportedChainId.OPTIMISM,
  id: SupportedNetwork.OPTIMISM,
  route: 'optimism',
  name: 'Optimism',
  bgColor: '#F01B36',
  primaryColor: '#F01B36',
  secondaryColor: '#FB7876',
  imageURL: OPTIMISM_LOGO_URL,
}

export const PolygonNetworkInfo: NetworkInfo = {
  chainId: SupportedChainId.POLYGON,
  id: SupportedNetwork.POLYGON,
  route: 'polygon',
  name: 'Polygon',
  bgColor: '#8247e5',
  primaryColor: '#8247e5',
  secondaryColor: '#FB7876',
  imageURL: POLYGON_LOGO_URL,
  blurb: '',
}
export const CeloNetworkInfo: NetworkInfo = {
  chainId: SupportedChainId.CELO,
  id: SupportedNetwork.CELO,
  route: 'celo',
  name: 'Celo',
  bgColor: '#02502F',
  primaryColor: '#35D07F',
  secondaryColor: '#9ACDB2',
  imageURL: CELO_LOGO_URL,
  blurb: '',
}

export const BNBNetworkInfo: NetworkInfo = {
  chainId: SupportedChainId.BNB,
  id: SupportedNetwork.BNB,
  route: 'bnb',
  name: 'BNB Chain',
  bgColor: '#e8cb7b',
  primaryColor: '#e8cb7b',
  secondaryColor: '#e8cb7b',
  imageURL: BNB_LOGO_URL,
  blurb: '',
}

export const SUPPORTED_NETWORK_VERSIONS: NetworkInfo[] = [
  EthereumNetworkInfo,
  PolygonNetworkInfo,
  OptimismNetworkInfo,
  AvalancheNetworkInfo,
  MantleNetworkInfo,
  LineaNetworkInfo,
  ArbitrumNetworkInfo,
  CeloNetworkInfo,
  BNBNetworkInfo,
]
